import { render } from "./rank-table.vue?vue&type=template&id=6561d68b&scoped=true"
import script from "./rank-table.vue?vue&type=script&lang=js"
export * from "./rank-table.vue?vue&type=script&lang=js"

import "./rank-table.vue?vue&type=style&index=0&id=6561d68b&scoped=true&lang=less"

import exportComponent from "/web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6561d68b"]])

export default __exports__